export interface FontsProps {
  headingFont: string
  textCondensedFont: string
  textFont: string
  fontSize46: string
  fontSize28: string
  fontSize13: string
  fontSize24: string
  fontSize18: string
  fontSize16: string
  fontSize14: string
  fontSize12: string
  fontSize10: string
  fontWeightNormal: string
  fontWeightMedium: string
  fontWeightSemiBold: string
  fontWeightBold: string
  letterSpacingNone: string
  letterSpacing: string
  letterSpacingBig: string
}

export const fontsSettings: FontsProps = {
  headingFont: 'Lora, Helvetica, Arial, sans-serif',
  textCondensedFont: 'Roboto Condensed, Helvetica, Arial, sans-serif',
  textFont: 'Roboto, Helvetica, Arial, sans-serif',
  // fontSize10: '10px',
  // fontSize12: '12px',
  // fontSize13: '13px',
  // fontSize14: '14px',
  // fontSize16: '16px',
  // fontSize18: '18px',
  // fontSize24: '24px',
  // fontSize28: '28px',
  // fontSize46: '46px',
  fontSize10: '0.625rem',
  fontSize12: '0.75rem',
  fontSize13: '0.813rem',
  fontSize14: '0.875rem',
  fontSize16: '1rem',
  fontSize18: '1.125rem',
  fontSize24: '1.5rem',
  fontSize28: '1.75rem',
  fontSize46: '2.875rem',
  fontWeightNormal: '400',
  fontWeightMedium: '500',
  fontWeightSemiBold: '600',
  fontWeightBold: '700',
  letterSpacingNone: '0px',
  letterSpacing: '0.2px',
  letterSpacingBig: '0.6px',
}
